<template>
    <div class='container'>
        <div class="details_item d-flex">
            <div class="left">

                <swiper :slides-per-view="1" :loop="false" :observer='true' :observeParents='true'>
                    <swiper-slide class="test">
                        <ImageLoader :key="index" :imageSrc="details.images" blank="true"
                            :altText="details.group_name" />
                    </swiper-slide>
                </swiper>
            </div>
            <div class="right">
                <!-- <div class="numbering">商品編號：C06201</div> -->
                <div class="name">{{ details.group_name }}</div>
                <div v-if="this.selectname == 0" class="price"><span>TWD $</span>{{ details.price_min |
                    formatNumberToqff }}
                </div>
                <div v-else class="price"><span>TWD $</span>{{ price | formatNumberToqff }}</div>
                <div class="member d-flex">
                    <label>會員</label>
                    <span class="d-flex">會員滿件滿額活動，請查閱詳情<i class=" icon-keyboard_arrow_right"></i>
                    </span>
                </div>
                <div class="select d-flex justify-content-between align-items-center">
                    <div class="title">商品規格</div>
                    <div class="prom_bar" data-bs-toggle="offcanvas" data-bs-target="#offcanvasBottom"
                        aria-controls="offcanvasBottom">
                        <label class="tags white_space mb-0">規格</label>
                        <div class="txt">共 {{ details?.items?.length }} 種規格可選</div>
                        <span class="more_btn"><i class="icon-keyboard_arrow_right"></i></span>
                    </div>
                    <div class="form_label pb-0" for="">選擇規格</div>
                    <select name="" id="" @change="clickvalue($event)" v-model="selectname">
                        <option value="0" checked="" disabled>請選擇</option>
                        <option v-for="item in details.items" :value="item.itemid">{{ item.name }}</option>
                    </select>
                </div>
                <div class="selectquantity d-flex justify-content-between align-items-center">
                    <div class="form_label pb-0" for="">數量</div>
                    <div class="selectquantity_select">
                        <div class=" number d-flex   justify-content-between ">
                            <button type="button" class="btn iconfont" @click="reduce()">&#xeaf5;
                            </button>
                            <input @change="numberchange(number)" type="text" name="quantity" v-model="number"
                                class="border-0 text-center w-100   p-0" data-max="1" data-min="1">
                            <button type="button" class="btn iconfont" @click="add()">&#xeaf3;
                            </button>
                        </div>
                    </div>
                </div>
                <div class="btns d-flex">
                    <div class="f-btn" style="cursor: pointer;" @click="addcart()"><i
                            class="icon-new_cart mr-5"></i>加入購物車
                    </div>
                    <div class="r-btn" style="cursor: pointer;" @click="gocart()">立即購買</div>
                </div>
                <div class="collection d-flex align-items-center">
                    <i class="icon-favorite_outline md-20 mr-5 p-0"></i>加入收藏
                </div>
                <div class="transport">運送&付款</div>
                <div class="transport_con">
                    <label class="manner list-unstyled">運送方式</label>
                    <ul class="list-unstyled d-flex">
                        <li>
                            <span>{{ displayContent }}</span>
                        </li>
                        <!-- <li>
                            <span>冷凍宅配</span>
                        </li>
                        <li>
                            <span>全家冷凍</span>
                        </li> -->
                    </ul>
                    <label class="manner list-unstyled">付款方式</label>
                    <ul class="list-unstyled d-flex">
                        <li>
                            <span>{{ displayPayment }}</span>
                        </li>
                        <!-- <li>
                            <span>LINE Pay</span>
                        </li>
                        <li>
                            <span>信用卡</span>
                        </li>
                        <li>
                            <span>ATM 虛擬帳號</span>
                        </li> -->
                    </ul>
                </div>
                <div class="mobile_btn" data-bs-toggle="offcanvas" data-bs-target="#offcanvasBottom"
                    aria-controls="offcanvasBottom">
                    我要購買
                </div>
                <div class="offcanvas offcanvas-bottom" style="border: none;" tabindex="-1" id="offcanvasBottom"
                    aria-labelledby="offcanvasBottomLabel">
                    <div class="offcanvas-body small">
                        <div class="icon_close" data-bs-dismiss="offcanvas">

                            <i class="icon-new_cross"></i>
                        </div>

                        <div class="top">
                            <div class="d_f">
                                <div class="img">
                                    <img :src="details.images" alt="">
                                </div>
                                <div class="text">
                                    {{ details.group_name }}
                                </div>
                            </div>
                            <div class="cont">
                                <div class="selectquantity_select">
                                    <div class=" number d-flex   justify-content-between ">
                                        <button type="button" class="btn iconfont" @click="reduce()">&#xeaf5;
                                        </button>
                                        <input @change="numberchange(number)" type="text" name="quantity"
                                            v-model="number" class="border-0 text-center w-100   p-0" data-max="1"
                                            data-min="1">
                                        <button type="button" class="btn iconfont" @click="add()">&#xeaf3;
                                        </button>
                                    </div>
                                </div>
                                <select name="" id="" @change="clickvalue($event)" v-model="selectname">
                                    <option value="0" checked="" disabled>請選擇</option>
                                    <option v-for="item in details.items" :value="item.itemid">{{ item.name }}</option>
                                </select>
                            </div>
                            <div v-if="this.selectname == 0" class="price" style="margin-top: 12px;">
                                <span>TWD $</span>{{
                    details.price_min |
                    formatNumberToqff }}
                            </div>
                            <div v-else class="price" style="margin-top: 12px;"><span>TWD $</span>{{ price |
                    formatNumberToqff }}</div>
                            <div class="mobtn d-flex">
                                <div id="addCart" data-bs-dismiss="" class="f-btn" style="cursor: pointer;"
                                    @click="addcart()">
                                    <i class="icon-new_cart mr-5"></i>加入購物車
                                </div>
                                <div id="goCart" data-bs-dismiss="" class="r-btn" style="cursor: pointer;"
                                    @click="gocart()">
                                    立即購買</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="details_cont">
            <div class="title">商品詳情</div>
            <hr>
            <p>▎商品介紹</p>
            <div v-for="item in details?.info?.desc">
                <img v-if="item.content_type == 'IMAGE'" :src="item.content" alt="">
                <div class="video-wrapper" v-else-if="item.content_type == 'YOUTUBE'">
                    <iframe :src="'https://www.youtube.com/embed/' + item.content.split('v=')[1].split('&')[0]"
                        frameborder="0" allowfullscreen></iframe>
                </div>
                <div v-else>
                    {{ item.content }}
                </div>
            </div>
            <div class="bottom_btn">
                <hr>
                <div class="selectquantity ">
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="form_label pb-0" for="">{{ details.group_name }}</div>
                        <div v-if="this.selectname == 0" class="price"><span>TWD $</span>{{ details.price_min |
                    formatNumberToqff }}</div>
                        <div v-else class="price"><span>TWD $</span>{{ price | formatNumberToqff }}</div>
                    </div>
                    <div class="selectquantity_select d-flex">
                        <select name="" id="" @change="clickvalue($event)" v-model="selectname">
                            <option value="0" checked="" disabled>請選擇</option>
                            <option v-for="item in details.items" :value="item.itemid">{{ item.name }}</option>
                            <!-- <option value="2">2</option> -->
                        </select>
                        <div class=" number d-flex   justify-content-between ">
                            <button type="button" class="btn iconfont" @click="reduce()">&#xeaf5;
                            </button>
                            <input @change="numberchange(number)" type="text" name="quantity" v-model="number"
                                class="border-0 text-center w-100   p-0" data-max="1" data-min="1">
                            <button type="button" class="btn iconfont" @click="add()">&#xeaf3;
                            </button>
                        </div>
                    </div>
                </div>
                <div class="btns d-flex">
                    <div class="f-btn" style="cursor: pointer;" @click="addcart()"><i
                            class="icon-new_cart mr-5"></i>加入購物車
                    </div>
                    <div class="r-btn" style="cursor: pointer;" @click="gocart()">立即購買</div>
                </div>

            </div>
        </div>
        <!-- 子商品模态框 -->
        <div class="modal fade child" id="details" tabindex="-1" aria-labelledby="exampleModalLabel2"
            aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="exampleModalLabel"> {{ content_name }} </h1>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <!-- {{ child_list }} -->
                        <h2 class="title">请选择{{ child_num }}件商品 </h2>
                        <div v-for="item, index in child_list">
                            <div class="form_name"> *{{ item.form_name }}</div>
                            <div class="number">
                                <button type="button" class="btn iconfont" @click="decrement(index)">-
                                </button>
                                <input type="number" name="quantity" @input="validateInput(index)"
                                    v-model="item.display_num" class=" text-center w-100   p-0" data-max="1"
                                    data-min="1">
                                <button type="button" class="btn iconfont" @click="increment(index)">+
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <!-- <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button> -->
                        <button type="button" class="btn btn-primary" @click="opmodef">確認</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'
import Swal from 'sweetalert2/dist/sweetalert2.all.js'
import { Navigation, Pagination } from 'swiper'
import { SwiperCore, Swiper, SwiperSlide } from 'swiper-vue2'
import 'swiper/swiper-bundle.css'
SwiperCore.use([Navigation, Pagination])
// Import Swiper styles
import numeral from "numeral";
import { mapState } from 'vuex'
import FacebookEventApi from '@/js/FacebookEventApi'
import ImageLoader from '@/components/Image_loading.vue'
export default {
    components: {
        Swiper,
        SwiperSlide,
        ImageLoader
    },
    data() {
        return {
            isMounted: false,
            selectname: '0',
            price: 0,
            number: 1,
            firstprice: 0,
            price: 0,
            contentImage: ['https://hinetcdn.waca.ec/uploads/shops/25040/products/51/516d0cf780115b23b2aab39eccc51519.jpg', 'https://hinetcdn.waca.ec/uploads/shops/25040/products/51/516d0cf780115b23b2aab39eccc51519.jpg'],


            // addtocart2
            content_name: '',//商品名字
            content_ids: '',//id
            values: '',//价格
            contents_quantity: '',//数量,

            isMobile: false,


            //child
            saveselectname: '',
            child_list: [],//子商品内容
            child_num: '',//子商品默认数量
            child_number: '',//记录商品数量总和
            parm: [],//修改后的子商品各个的数量


            //赠品
            free: [],//赠品
            free_num: '',//赠品数量
            free_number: '',//记录赠品数量总和
            free_parm: [],//修改后的赠品各个的数量
        };
    },
    computed: {
        ...mapState('commodity', ['details']),
        ...mapState('header', ['getfb', 'getfront']),
        ...mapState('cart', ['cart_list_item']),
        displayContent() {
            if (this.getfront && this.getfront.length > 3) {
                return this.getfront[3].content || '宅配';
            }
            return '宅配';

        },
        displayPayment() {
            if (this.getfront && this.getfront.length > 4) {
                return this.getfront[4].content || '貨到付款、信用卡、ATM轉帳';
            }
            return '貨到付款、信用卡、ATM轉帳';

        },
        convertToEmbedUrl(url) {
            // String(url).split(...); Q：这是什么意思？
            // console.log(url);
            const videoId = String(url).split('v=')[1].split('&')[0];
            // console.log(videoId);
            return url;
            return `https://www.youtube.com/embed/${videoId}`;
        },
        totalSum() {
            return this.child_list.reduce((sum, item) => sum + item.display_num, 0);
        }
    },
    filters: {
        formatNumberToqff(val) {
            return numeral(val).format('0,0');
        }
    },
    watch: {

    },
    methods: {
        opmodef() {
            let number = 0
            this.parm = this.child_list.map(item => {
                number += item.display_num
                return {
                    item: item.isubid,
                    num: item.display_num
                };
            });

            if (number == this.child_num) {
                this.selectname = this.saveselectname;
                const myModal = this.$bootstrap.Modal.getInstance(document.getElementById('details'));
                myModal.hide();
                if (window.innerWidth <= 767) {
                    const myModal2 = new this.$bootstrap.Offcanvas(document.getElementById('offcanvasBottom'));
                    myModal2.show();
                }
            } else {
                const Toast = Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 1500,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    }
                })

                Toast.fire({
                    icon: 'warning',
                    title: `數量選擇有錯哦! 您可以選 ${this.child_num} 樣商品^_^`
                })
            }
        },
        clickvalue(e) {
            // console.log($('#goCart')[0].dataset.bsDismiss);
            // console.log($('#addCart')[0].dataset.bsDismiss);
            this.parm = [];
            this.details.items.forEach(element => {
                if (element.itemid === this.selectname) {

                    this.$store.dispatch('commodity/getsubcategory', this.selectname).then(response => {
                        if (response.result) {
                            this.child_list = response.data.sub || [];
                            this.child_num = response.data.num || 0;
                            this.free = response.data.sub_free || [];
                            this.free_num = response.data.num_free || 0;
                            if (response.data.sub?.length === 1) {
                                this.child_list[0].display_num = response.data.num
                                this.parm = [
                                    {
                                        item: response.data.sub[0].isubid,
                                        num: response.data.num
                                    }
                                ]
                                if (window.innerWidth <= 767) {
                                    const myModal2 = this.$bootstrap.Offcanvas.getInstance(document.getElementById('offcanvasBottom'));
                                    myModal2.hide();
                                }
                            } else if (response.data.sub?.length > 0) {
                                const myModal = new this.$bootstrap.Modal(document.getElementById('details'));
                                myModal.show();
                                this.saveselectname = this.selectname;

                            } else {
                                this.child_num = 0;
                                this.child_list = []
                            }
                        } else {
                            const Toast = Swal.mixin({
                                toast: true,
                                position: 'top-end',
                                showConfirmButton: false,
                                timer: 1500,
                                didOpen: (toast) => {
                                    toast.addEventListener('mouseenter', Swal.stopTimer)
                                    toast.addEventListener('mouseleave', Swal.resumeTimer)
                                }
                            })

                            Toast.fire({
                                icon: 'error',
                                title: `${response.message}`
                            })
                        }
                        // $('#myModal').modal('show');
                        // console.log($('#myModal'));
                        // console.log($('#myModal').modal());
                    });
                    this.firstprice = element.price;
                    this.price = element.price * this.number;
                    // addtocart2
                    this.content_name = element.name;
                    this.content_ids = element.itemid;
                    this.values = element.price;
                    this.contents_quantity = 1;
                    $('#addCart')[0].dataset.bsDismiss = "offcanvas"
                    $('#goCart')[0].dataset.bsDismiss = "offcanvas"
                } else {
                }
            })
        },
        numberchange(e) {
            this.price = this.firstprice * this.number

        },
        // 数量减
        reduce() {
            if (this.number > 1) {
                this.number--;
                this.price = this.firstprice * this.number
            }
        },
        // 数量加
        add() {

            if (this.number < 99) {
                this.number++;
                this.price = this.firstprice * this.number
            }

        },
        // 加入购物车
        addcart() {
            if (this.selectname == 0) {
                const Toast = Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 1500,
                    // timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    }
                })

                Toast.fire({
                    icon: 'error',
                    title: '請選擇規格'
                })
            } else {
                var myFacebookEventApi = new FacebookEventApi(this.getfb.ShenV1FbPixel1, this.getfb.ShenV1FbPixel1_hash);
                var fb_em = myFacebookEventApi.fbgetCookie('em');
                var fb_phone = myFacebookEventApi.fbgetCookie('phone');
                var fb_fn = myFacebookEventApi.fbgetCookie('fn');
                var fb_external_id = myFacebookEventApi.fbgetCookie('external_id');
                var fb_fbclid = myFacebookEventApi.fbgetCookie('fbclid');
                myFacebookEventApi.callAddToCart2('item' + this.content_ids, this.content_name, this.contents_quantity, this.values, fb_em, fb_phone, fb_fn, fb_external_id, fb_fbclid);
                if (this.totalSum !== this.child_num) {
                    const myModal = new this.$bootstrap.Modal(document.getElementById('details'));
                    myModal.show();
                } else {
                    if (this.parm.length !== 0) {

                        this.parm = this.child_list.map(item => {
                            return {
                                item: item.isubid,
                                num: item.display_num
                            };
                        });
                        this.parm.forEach(element => {
                            element.num = element.num * this.number;
                        });
                    }
                    if (this.free.length !== 0) {
                        this.free_parm = this.free.map(item => {
                            return {
                                item: item.isubid,
                                num: this.free_num * this.number
                            };
                        });
                    }
                    this.child_number = this.number
                    if (this.cart_list_item.length !== 0) {
                        this.cart_list_item.forEach(element => {
                            if (this.selectname == element.item_id) {
                                this.child_number += element.num
                                element.sub.forEach(sub_item => {
                                    const existingItem = this.parm.find(item1 => item1.item === sub_item.isubid);
                                    if (existingItem) {
                                        // 如果存在，则将数量相加
                                        existingItem.num += sub_item.num;
                                    }
                                    const free_existingItem = this.free_parm.find(item1 => item1.item === sub_item.isubid);
                                    if (free_existingItem) {
                                        // 如果存在，则将数量相加
                                        free_existingItem.num += sub_item.num;
                                    }
                                });
                            }
                        });
                    }
                    this.parm = this.parm.concat(this.free_parm);
                    this.free_parm = []
                    this.$store.dispatch('cart/add', {
                        action: 'UPDATE',
                        itemid: this.selectname,
                        number: this.child_number,
                        type: 'NOR',
                        param: this.parm,
                    }).then((e) => {
                        const Toast = Swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 1500,
                            didOpen: (toast) => {
                                toast.addEventListener('mouseenter', Swal.stopTimer)
                                toast.addEventListener('mouseleave', Swal.resumeTimer)
                            }
                        })
                        if (e.result) {
                            Toast.fire({
                                icon: 'success',
                                title: '成功加入購物車'
                            })
                        } else {
                            Toast.fire({
                                icon: 'error',
                                title: `${e.message}`
                            })
                        }
                    });

                    if (window.innerWidth <= 767) {
                        const myModal2 = new this.$bootstrap.Offcanvas(document.getElementById('offcanvasBottom'));
                        myModal2.hide();
                    }
                }
                // this.$store.dispatch('cart/add', {
                //     action: 'UPDATE',
                //     itemid: this.selectname,
                //     number: this.number,
                //     type: 'NOR',
                //     param: this.parm,
                // }).then(() => {
                //     const Toast = Swal.mixin({
                //         toast: true,
                //         position: 'top-end',
                //         showConfirmButton: false,
                //         timer: 1500,
                //         didOpen: (toast) => {
                //             toast.addEventListener('mouseenter', Swal.stopTimer)
                //             toast.addEventListener('mouseleave', Swal.resumeTimer)
                //         }
                //     })

                //     Toast.fire({
                //         icon: 'success',
                //         title: '成功加入購物車'
                //     })
                // });
            }
        },
        // 立即购买
        gocart() {
            if (this.selectname == 0) {
                const Toast = Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 1500,
                    // timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    }
                })

                Toast.fire({
                    icon: 'error',
                    title: '請選擇規格'
                })

            } else {
                var myFacebookEventApi = new FacebookEventApi(this.getfb.ShenV1FbPixel1, this.getfb.ShenV1FbPixel1_hash, this.getfb.ShenV1FbPixel1_domain);
                var fb_em = myFacebookEventApi.fbgetCookie('em');
                var fb_phone = myFacebookEventApi.fbgetCookie('phone');
                var fb_fn = myFacebookEventApi.fbgetCookie('fn');
                var fb_external_id = myFacebookEventApi.fbgetCookie('external_id');
                var fb_fbclid = myFacebookEventApi.fbgetCookie('fbclid');
                myFacebookEventApi.callAddToCart2('item' + this.content_ids, this.content_name, this.contents_quantity, this.value, fb_em, fb_phone, fb_fn, fb_external_id, fb_fbclid);
                // this.$store.dispatch('cart/add', {
                //     itemid: this.selectname,
                //     number: this.number,
                // }).then(response => {
                //     this.$router.push({
                //         path: `/cart`
                //     }).catch(err => { })
                // });
                if (this.totalSum !== this.child_num) {
                    const myModal = new this.$bootstrap.Modal(document.getElementById('details'));
                    myModal.show();
                } else {
                    if (this.parm.length !== 0) {

                        this.parm = this.child_list.map(item => {
                            return {
                                item: item.isubid,
                                num: item.display_num
                            };
                        });
                        this.parm.forEach(element => {
                            element.num = element.num * this.number;
                        });
                    }
                    if (this.free.length !== 0) {
                        this.free_parm = this.free.map(item => {
                            return {
                                item: item.isubid,
                                num: this.free_num * this.number
                            };
                        });
                    } else {
                        this.free_parm = []
                    }
                    this.child_number = this.number
                    if (this.cart_list_item.length !== 0) {
                        this.cart_list_item.forEach(element => {
                            if (this.selectname == element.item_id) {
                                this.child_number += element.num
                                element.sub.forEach(sub_item => {
                                    const existingItem = this.parm.find(item1 => item1.item === sub_item.isubid);
                                    if (existingItem) {
                                        // 如果存在，则将数量相加
                                        existingItem.num += sub_item.num;
                                    }
                                    const free_existingItem = this.free_parm.find(item1 => item1.item === sub_item.isubid);
                                    if (free_existingItem) {
                                        // 如果存在，则将数量相加
                                        free_existingItem.num += sub_item.num;
                                    }
                                });
                            }
                        });
                    }
                    this.parm = this.parm.concat(this.free_parm);
                    this.free_parm = []
                    this.$store.dispatch('cart/add', {
                        action: 'UPDATE',
                        itemid: this.selectname,
                        number: this.child_number,
                        type: 'NOR',
                        param: this.parm,
                    }).then((e) => {
                        const Toast = Swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 1500,
                            didOpen: (toast) => {
                                toast.addEventListener('mouseenter', Swal.stopTimer)
                                toast.addEventListener('mouseleave', Swal.resumeTimer)
                            }
                        })
                        if (e.result) {
                            Toast.fire({
                                icon: 'success',
                                title: '成功加入購物車'
                            })
                            this.$router.push({
                                path: `/cart`
                            }).catch(err => { })
                        } else {
                            Toast.fire({
                                icon: 'error',
                                title: `${e.message}`
                            })
                        }
                    });

                    if (window.innerWidth <= 767) {
                        const myModal2 = new this.$bootstrap.Offcanvas(document.getElementById('offcanvasBottom'));
                        myModal2.hide();
                    }
                }
            }
        },
        increment(index) {
            if (this.totalSum < this.child_num) {
                this.child_list[index].display_num++;
            }
        },
        validateInput(index) {
            // 确保当前输入是一个有效数字
            this.child_list[index].display_num = Math.max(0, parseInt(this.child_list[index].display_num) || 0);

            // 计算所有 display_num 的总和
            let total = this.child_list.reduce((sum, item) => sum + item.display_num, 0);

            // 如果总和超过 child_num，则减少当前输入的值
            if (total > this.child_num) {
                let excess = total - this.child_num;
                this.child_list[index].display_num = Math.max(0, this.child_list[index].display_num - excess);
            }
        },
        decrement(index) {
            if (this.child_list[index].display_num > 0) {
                this.child_list[index].display_num--;
            }
        },
    },
    created() {
    },
    mounted() {

        //          if (window.innerWidth > 600) {
        //             this.isMobile = false;
        //         } else {
        //             this.isMobile = true;

        //         }
        this.isMounted = true;
        this.$store.dispatch('commodity/getdesignated_product', this.$route.params.id).then(response => {
            // if (this.details.items.length == 1) {
            //     this.selectname = this.details.items[0].itemid;
            //     this.firstprice = this.details.items[0].price;
            //     this.price = this.details.items[0].price * this.number;
            //     // addtocart2
            //     this.content_name = this.details.items[0].name;
            //     this.content_ids = this.details.items[0].itemid;
            //     this.values = this.details.items[0].price;
            //     this.contents_quantity = 1;
            // }
            // this.details.items
        })
    },
}
</script>

<style lang='scss' scoped src="./index.scss"></style>

<style lang="scss" scoped>
.video-wrapper {
    position: relative;
    padding-bottom: 56.25%;
    /* 16:9 */
    height: 0;
}

.video-wrapper iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.child {




    h2 {
        margin: 0 0 16px;
    }

    .form_name {
        color: black;
        font-size: 16px;
    }

    .number {
        margin-bottom: 16px;
        display: flex;
        justify-content: space-between;
        height: 40px;

        input {
            width: 100%;
            height: 40px;
            text-align: center;
            // max-height: 36px;
            outline-style: none;
            border: 1px solid #e2e2e2;
            border-left: none;
            border-right: none;

            &:focus {}
        }

        button {
            background-color: #fff;
            color: #BBB19E;
            height: 40px;
            line-height: 1.5px;
            padding: 6px 12px;
            border: 1px solid #e2e2e2;
            border-radius: 5px;
            cursor: pointer;

            &:not(:first-child) {
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
                font-size: 30px;
                // line-height: 1;
            }

            &:first-child {
                font-size: 38px;

                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
            }
        }

        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        /* 针对 Firefox */
        input[type=number] {
            -moz-appearance: textfield;
        }

        /* 针对 IE11 */
        input[type=number]::-ms-clear {
            display: none;
        }

    }

    .btn {
        text-align: center;

        button {
            height: 40px;
            width: 100px;
            /* 重置边框和背景样式 */
            border: none;
            background: none;
            /* 重置内外边距 */
            padding: 0;
            margin: 0;
            /* 设置字体样式 */
            font-family: inherit;
            font-size: inherit;
            /* 设置颜色 */
            color: inherit;
            /* 设置鼠标样式 */
            cursor: pointer;
            /* 去除按钮的外观 */
            appearance: none;
            /* 其他可能需要的样式 */
            /* outline: none; */
            /* 注意：如果使用 outline: none;，请提供其他焦点样式以保持可访问性 */
            /* 其他重置样式，根据需要添加 */
            background-color: #11ADD8;
            color: white;
            border-radius: 5px;
        }
    }




}
</style>